const isActiveLink = ({ isCurrent }) => (
  isCurrent ? { className: 'active' } : null
)

export default isActiveLink
